export const chargeColumns = [
  {
    id: "numericAccountId",
    displayName: "Account ID",
    headerName: "Account ID",
    field: "numericAccountId",
    flex: 1,
  },
  {
    id: "chargeId",
    displayName: "Charge ID",
    headerName: "Charge ID",
    field: "chargeId",
    flex: 1,
  },
  {
    id: "accountName",
    displayName: "Account name",
    headerName: "Account name",
    field: "accountName",
    flex: 1,
  },
  {
    id: "ledgerName",
    displayName: "Ledger name",
    headerName: "Ledger name",
    field: "ledgerName",
    flex: 1,
  },

  {
    id: "subLedgerName",
    displayName: "Sub ledger name",
    headerName: "Sub ledger name",
    field: "subLedgerName",
    flex: 1,
  },
  {
    id: "dueDate",
    displayName: "Due date",
    headerName: "Due date",
    field: "dueDate",
    flex: 1,
  },
  {
    id: "amount",
    displayName: "Amount",
    headerName: "Amount",
    field: "amount",
    flex: 1,
  },
  {
    id: "discount",
    displayName: "Discount",
    headerName: "Discount",
    field: "discount",
    flex: 1,
  },
  {
    id: "paid",
    displayName: "Paid",
    headerName: "Paid",
    field: "paid",
    flex: 1,
  },
  {
    id: "amountDue",
    displayName: "Amount Due",
    headerName: "Amount Due",
    field: "amountDue",
    flex: 1,
  },
  {
    id: "invoiceNote",
    displayName: "Invoice Note",
    headerName: "Invoice Note",
    field: "invoiceNote",
    flex: 1,
  },
];

export const paymentColumns = [
  {
    id: "numericAccountId",
    displayName: "Account ID",
    headerName: "Account ID",
    field: "numericAccountId",
    flex: 1,
  },
  {
    id: "paymentId",
    displayName: "Payment ID",
    headerName: "Payment ID",
    field: "paymentId",
    flex: 1,
  },
  {
    id: "chargeId",
    displayName: "Charge ID",
    headerName: "Charge ID",
    field: "chargeId",
    flex: 1,
  },
  {
    id: "accountName",
    displayName: "Account name",
    headerName: "Account name",
    field: "accountName",
    flex: 1,
  },
  {
    id: "ledgerName",
    displayName: "Ledger name",
    headerName: "Ledger name",
    field: "ledgerName",
    flex: 1,
  },

  {
    id: "subLedgerName",
    displayName: "Sub ledger name",
    headerName: "Sub ledger name",
    field: "subLedgerName",
    flex: 1,
  },
  {
    id: "paidDate",
    displayName: "Paid date",
    headerName: "Paid date",
    field: "paidDate",
    flex: 1,
  },
  {
    id: "amount",
    displayName: "Amount",
    headerName: "Amount",
    field: "amount",
    flex: 1,
  },
  {
    id: "paymentMethod",
    displayName: "Payment Method",
    headerName: "Payment Method",
    field: "paymentMethod",
    flex: 1,
  },
  {
    id: "receiptNote",
    displayName: "Receipt Note",
    headerName: "Receipt Note",
    field: "receiptNote",
    flex: 1,
  },
];

export const accountColumns = [

  {
    id: "mailFamilyName",
    displayName: "Mailing Label Name",
    headerName: "Mailing Label Name",
    field: "mailFamilyName",
    flex: 1,
  },

  {
    id: "address1",
    displayName: "Address 1",
    headerName: "Address 1",
    field: "address1",
    flex: 1,
  },
  {
    id: "address1Line2",
    displayName: "Address 1 Line 2",
    headerName: "Address 1 Line 2",
    field: "address1Line2",
    flex: 1,
  },
  {
    id: "address1City",
    displayName: "Address 1 City",
    headerName: "Address 1 City",
    field: "address1City",
    flex: 1,
  },
  {
    id: "address1State",
    displayName: "Address 1 State",
    headerName: "Address 1 State",
    field: "address1State",
    flex: 1,
  },
  {
    id: "address1ZipCode",
    displayName: "Address 1 Zip Code",
    headerName: "Address 1 Zip Code",
    field: "address1ZipCode",
    flex: 1,
  },

  {
    id: "address1Country",
    displayName: "Address 1 Country",
    headerName: "Address 1 Country",
    field: "address1Country",
    flex: 1,
  },
  {
    id: "adult1Title",
    displayName: "Adult 1 Title",
    headerName: "Adult 1 Title",
    field: "adult1Title",
    flex: 1,
  },
  {
    id: "adult1FirstName",
    displayName: "Adult 1 First Name",
    headerName: "Adult 1 First Name",
    field: "adult1FirstName",
    flex: 1,
  },
  {
    id: "adult1LastName",
    displayName: "Adult 1 Last Name",
    headerName: "Adult 1 Last Name",
    field: "adult1LastName",
    flex: 1,
  },
  // {
  //   id: "Adult 1 Last Name",
  //   displayName: "Adult 1 Last Name",
  //   headerName: "Adult 1 Last Name",
  //   field: "Adult 1 Last Name",
  //   flex: 1,
  // },
  {
    id: "adult1Email",
    displayName: "Adult 1 Email",
    headerName: "Adult 1 Email",
    field: "adult1Email",
    flex: 1,
  },
  {
    id: "adult1Mobile",
    displayName: "Adult 1 Mobile",
    headerName: "Adult 1 Mobile",
    field: "adult1Mobile",
    flex: 1,
  },


  {
    id: "adult2Title",
    displayName: "Adult 2 Title",
    headerName: "Adult 2 Title",
    field: "adult2Title",
    flex: 1,
  },
  {
    id: "adult2FirstName",
    displayName: "Adult 2 First Name",
    headerName: "Adult 2 First Name",
    field: "adult2FirstName",
    flex: 1,
  },
  {
    id: "adult2LastName",
    displayName: "Adult 2 Last Name",
    headerName: "Adult 2 Last Name",
    field: "adult2LastName",
    flex: 1,
  },
  {
    id: "adult2Email",
    displayName: "Adult 2 Email",
    headerName: "Adult 2 Email",
    field: "adult2Email",
    flex: 1,
  }
  ,
  {
    id: "adult2Mobile",
    displayName: "Adult 2 Mobile",
    headerName: "Adult 2 Mobile",
    field: "adult2Mobile",
    flex: 1,
  },
  {
    id: "currentPhone",
    displayName: "Current Phone",
    headerName: "Current Phone",
    field: "currentPhone",
    flex: 1,
  }

];
